import styled from 'styled-components';
import Button from 'core/common/components/ButtonDeprecated';
import Title from 'core/common/components/Title';

export const StyledButton = styled(Button)`
  position: ${({ disabled }) => (disabled ? 'static' : 'sticky')};
  bottom: 20px;
  height: 50px;
  margin-top: 10px;
  margin-bottom: 27px;
  border-radius: 16px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 708px;
  margin: 0 auto;
`;

export const StyledTitle = styled(Title)`
  margin-bottom: 30px;
  font-size: 24px;
  line-height: 28px;
  text-align: left;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 466px;
  margin: 0 auto;
`;

export const StyledList = styled(List)`
  margin-top: 10px;
`;

export const Text = styled.p`
  flex-grow: 1;
  font-size: 14px;
  line-height: 20px;
`;

export const Item = styled.li`
  margin-bottom: 20px;
`;

export const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-left: auto;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.typography100};
`;
